import {checkInView} from "../dom-helper";
import {LOADING_IMAGE} from "../../common/constants";
import ImageHelper from "../image-helper";
import { IMAGE_LAZY_LOAD_STATUS } from '../../common/constants';

export default class ImageLazyLoader {
  update(el, binding) {
    const preventRerender = el.getAttribute('prevent-rerender');
    const lazyStatus = el.getAttribute('lazy-status') || 0;
    if (preventRerender == "true" && parseInt(lazyStatus) === IMAGE_LAZY_LOAD_STATUS.LOADED) {
      return;
    }
    el.setAttribute("lazy-status", "0");
    el.binding = binding;
    el.loadImage();
  }
	
	inserted(el , binding, vnode) {
		try {
			const container = document.querySelector(
				el.getAttribute("data-container")
			);
			el.setAttribute("lazy-status" , "0");
			if (container && checkInView(container , el , true)) {
				el.loadImage();
			}
		} catch (e) {
		    vnode.context.$forceUpdate();
		}
	}

  bind(el, binding) {
    el.binding = binding;
    el.src = LOADING_IMAGE;
    el.style = "object-fit: scale-down"
    ImageLazyLoader.initEvent(el);
  }

  static initEvent(el) {
    el.loadImage = callback => {
      if (el.getAttribute("lazy-status") == "0") {
        ImageHelper.populateImageUrl(el, el.binding.value, true, callback);
      }
    };

    setTimeout(() => {
      const container = document.querySelector(
        el.getAttribute("data-container")
      );

      el.setAttribute("lazy-status", "0");
      
      if (container) {
        el.inViewScrollEvent = () => {
          if (checkInView(container, el, true)) {
            el.loadImage();
          }
        };

        container.addEventListener("scroll", el.inViewScrollEvent);
      }
    }, 500);
  }

  static disableEvent(el) {
    const container = document.querySelector(el.getAttribute("data-container"));

    if (container) {
      container.removeEventListener("scroll", el.inViewScrollEvent);
    }
  }
}
